module.exports = __webpack_public_path__ + "static/media/Carroll-Farms-Condominium-By-Laws.1a19b13e.pdf";